// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"94":"8862c2589b68df0b2cdb","472":"ccbf1153bd28bfd6b9ea"}[chunkId] + ".css";
};